import {
    ApolloClient,
    ApolloProvider,
    NormalizedCacheObject,
} from '@apollo/client'
import {
    AuthContext,
    IAuthContext,
} from '@deltek/specification-client/core/Configurations/AuthContext'
import { getApolloBaseClient } from '@deltek/specification-client/core/Configurations/apolloBaseClient'
import { createNetworkErrorLink } from 'api/graphQL/networkErrorLogger'
import typePolicies from 'api/graphQL/policies/main.policies'
import resolvers from 'api/graphQL/resolvers/main.resolvers'
import { CachePersistor } from 'apollo-cache-persist'
import { cacheWatcher } from 'components/configuration/ApolloCacheWatcher'
import React, { useContext, useEffect, useState } from 'react'
import { processEnv } from './environmentVariables'
const ApolloConfiguration = ({ children }: { children?: React.ReactNode }) => {
    const { getToken } = useContext<IAuthContext>(AuthContext)
    const [client, setClient] = useState<
        ApolloClient<NormalizedCacheObject> | undefined
    >()
    const [persistor, setPersistor] = useState<
        CachePersistor<unknown> | undefined
    >()

    // Initialize Apollo client once; prepend network error link for 499 logging
    useEffect(() => {
        if (!!client) return
        getApolloBaseClient({
            graphQLUri: processEnv.REACT_APP_GraphQLUri,
            resolvers,
            typePolicies,
        })
            .then((response) => {
                if (!response) return
                const errorLink = createNetworkErrorLink()
                response.client.setLink(
                    errorLink.concat(response.client.link)
                )
                setClient(response.client)
                setPersistor(response.persistor)
            })
    }, [client, getToken])

    // Monitor cache size and evict workspace tree data if over threshold
    useEffect(() => {
        if (!(client && persistor)) return

        return cacheWatcher(client, persistor)
    }, [client, persistor])

    if (!(client && persistor)) return null

    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloConfiguration
